import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function SystemOverview() {
  const tags = ['Recetas sin gluten', 'Organización semanal', 'Colaciones saludables', 'Horarios recomendados', 'Alimentación para cada edad', 'Hábitos saludables', 'Consejos prácticos', 'Bienestar digestivo', 'Vida saludable sin TACC'];
  return <section className="py-20 px-4" data-id="element-162">
      <div className="max-w-4xl mx-auto text-center" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-164">
          <span className="text-sage font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-165">
            Sistema Completo
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-forest mb-6" data-id="element-166">
            6 Módulos + 6 Bonos
          </h2>
          <p className="text-xl text-muted mb-12" data-id="element-167">
            Todo organizado para ayudarte a mantener una alimentación saludable
            y segura.
          </p>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4" data-id="element-168">
            {tags.map((tag, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} className="bg-warm-white border border-sage/20 px-5 py-3 rounded-full flex items-center gap-2 shadow-sm" data-id="element-169">
                <Check className="w-4 h-4 text-sage" data-id="element-170" />
                <span className="font-medium text-forest" data-id="element-171">{tag}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}